module.exports = __webpack_public_path__ + "static/the-man-who-knew-infinity-34cca32995bca6f1f34d328e2e0be007.jpg";